import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import { Routes, Route } from 'react-router-dom';
import { FaStar } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styless
import 'swiper/css';

/* 라우트 */
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BiSearch } from 'react-icons/bi';

/* 컴포넌트 */
import Header from '../components/Header';
import Footer from '../components/Footer';

const Fsearch = () => {
    return (
        <>
            {/* 헤더 */}
            <Header />
            {/* 컨텐츠 */}
            <Routes>
                <Route path='/' element={
                    <>
                        {/* 검색창 */}
                        <Container>
                            <Form id="search1">
                                <Form.Control
                                    type="search"
                                    placeholder="디자이너,헤어샵 검색"
                                    className="search_bar"
                                    aria-label="Search"
                                />
                                <Button className='btn' variant="light">
                                    <BiSearch />
                                </Button>
                            </Form>
                        </Container>
                        <Swiper
                            id='swiper1'
                            spaceBetween={10}
                            slidesPerView={4}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide className="slide1">가격순</SwiperSlide>
                            <SwiperSlide className="slide1">1인샵</SwiperSlide>
                            <SwiperSlide className="slide1">바버샵</SwiperSlide>
                            <SwiperSlide className="slide1">헤어샵</SwiperSlide>
                            <SwiperSlide className="slide1">리뷰순</SwiperSlide>
                            <SwiperSlide className="slide1">별점순</SwiperSlide>
                        </Swiper>
                        <Link to='/DetailPage' className='undernone'>
                            <Swiper
                                id='swiper2'
                                spaceBetween={8}
                                slidesPerView={1}
                                onSlideChange={() => console.log('slide change')}
                                onSwiper={(swiper) => console.log(swiper)}
                            >
                                <SwiperSlide id="slide2">
                                </SwiperSlide>
                                <br />
                               <p className='slide_title'>인스타헤어 동수원점</p>
                                <p className='slide_information'><FaStar fill='orange' />&nbsp; 4.9 (533) | &nbsp;10:00 ~ 21:00 &nbsp;| &nbsp; 커트 25,000원~</p>
                                <p className='slide_text'>
                                    수병원과 지동우체국 사이 심환빌 2층입니다.
                                </p>
                                <SwiperSlide id="slide2-1"></SwiperSlide>
                                <SwiperSlide id="slide2-2"></SwiperSlide>
                                <SwiperSlide id="slide2-3"></SwiperSlide>
                            </Swiper>
                        </Link>


                        <div className='slide_line'></div>
                        <Swiper
                            id='swiper3'
                            spaceBetween={8}
                            slidesPerView={1}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide id="slide3">
                            </SwiperSlide>
                            <br />
                            <p className='slide_title'>리안헤어 북수원CGV점</p>
                            <p className='slide_information'><FaStar fill='orange' />&nbsp; 4.8 (1,108) | &nbsp;10:00 ~ 21:00 &nbsp;| &nbsp; 커트 17,000원~</p>
                            <p className='slide_text'>
                                북수원CGV건물 리안헤어
                            </p>
                            <SwiperSlide id="slide3-1"></SwiperSlide>
                            <SwiperSlide id="slide3-2"></SwiperSlide>
                        </Swiper>

                        <div className='slide_line'></div>
                        <Swiper
                            id='swiper4'
                            spaceBetween={8}
                            slidesPerView={1}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide id="slide4">
                            </SwiperSlide>
                            <br />
                            <p className='slide_title'>굿헤어데이즈</p>
                            <p className='slide_information'><FaStar fill='orange' />&nbsp; 4.9 (185) | &nbsp;10:00 ~ 20:00 &nbsp;| &nbsp; 커트 33,000원~</p>
                            <p className='slide_text'>
                                ★아베다 공식 파트너 살롱★ 수원역 9번출구 도보 10분이내
                            </p>
                            <SwiperSlide id="slide4-1"></SwiperSlide>
                            <SwiperSlide id="slide4-2"></SwiperSlide>
                        </Swiper>

                        <div className='slide_line'></div>

                        <Swiper
                            id='swiper5'
                            spaceBetween={8}
                            slidesPerView={1}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide id="slide5">
                            </SwiperSlide>
                            <br />
                            <p className='slide_title'>345헤어살롱</p>
                            <p className='slide_information'><FaStar fill='orange' />&nbsp; 4.8 (2,045) | &nbsp;10:30 ~ 20:30 &nbsp;| &nbsp; 커트 15,000원~</p>
                            <p className='slide_text'>
                                수원홈플러스 맞은편 건물 2층 버스정류장 뒤 1층에 미소야 알파···
                            </p>
                            <SwiperSlide id="slide5-1"></SwiperSlide>
                            <SwiperSlide id="slide5-2"></SwiperSlide>
                            <SwiperSlide id="slide5-3"></SwiperSlide>
                        </Swiper>

                        <div className='slide_line'></div>
                        <Swiper
                            id='swiper6'
                            spaceBetween={8}
                            slidesPerView={1}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide id="slide6">
                            </SwiperSlide>
                            <br />
                            <p className='slide_title'>보그헤어 북수원조원점</p>
                            <p className='slide_information'><FaStar fill='orange' />&nbsp; 4.9 (120) | &nbsp;10:00 ~ 21:00 &nbsp;| &nbsp; 커트 15,000원~</p>
                            <p className='slide_text'>
                                조원동 KT위즈파크 맞은편 건물 2층
                            </p>
                            <SwiperSlide id="slide6-1"></SwiperSlide>
                            <SwiperSlide id="slide6-2"></SwiperSlide>
                        </Swiper>

                    </>
                } />
            </Routes>
            {/* 푸터 */}
            <Footer />
        </>
    )
};

export default Fsearch;